import React from 'react'
import NavBarItem from "../components/NavBarItem"
import {tooltips} from "../constants"
import {connect} from "react-redux"
import {toggleSettings} from "../actions"

const Settings = ({name, icon, dispatch}) => (
    <NavBarItem tooltip={tooltips.Settings} name={name} onClick = {()=> dispatch(toggleSettings({"screen":"settings"}))} icon={icon} />
)

export default connect()(Settings)